import { Expose, Type } from 'class-transformer';
import { DoorSpec } from './door-spec';
import { DoorType } from './door-type';

export class VehicleDoorsSpec {
    @Expose()
    @Type(() => DoorSpec)
    doors: DoorSpec[];

    visibleFormat(): string {
        const size = this.doors.filter(door => door.doorType !== DoorType.NONE).length;
        const layout = this.layout();
        const width = this.doors.map(door => door.doorWidth || 0).join('-');
        const thresholds = this.doors.map(door => door.doorThresholdHeight || 0).join('-');
        return `${size}, ${layout}, ${width}, ${thresholds}`;
    }

    layout(): string {
        return this.doors.map(door => {
            switch (door.doorType) {
                case 'NONE': return 0;
                case 'SINGLE': return 1;
                case 'DOUBLE': return 2;
            }
        }).join('-');
    }
}

/**
 * Create default doors specification for layout.
 *
 * @param layout layout eg. '2-2-1', '2-0-2' '1-2-2-2-1' etc.
 * @returns Doors specification for given layout.
 */
export function createFromLayout(layout: string): DoorSpec[] {
    const doors: DoorSpec[] = [];
    let doorNumber = 0;
    if (isValidLayout(layout)) {
        layout.split('-').forEach((v) => {
            switch (v) {
                case '0':
                    doors.push(({ doorNumber: 0, doorType: DoorType.NONE }));
                    break;
                case '1':
                    doors.push(({ doorNumber: ++doorNumber, doorType: DoorType.SINGLE }));
                    break;
                case '2':
                    doors.push(({ doorNumber: ++doorNumber, doorType: DoorType.DOUBLE }));
                    break;
            }
        });
    }
    return doors;

}

export function isValidLayout(layout: string): boolean {
    const pattern: RegExp = new RegExp('^([0-2]-){2,}[0-2]$');
    return pattern.test(layout);
}
